import genericStore from "../generic_store";
import axios from "axios";
import { config } from "../../config/constants";
export default {
  namespaced: genericStore.namespaced,
  state: {
    ...genericStore.state,
    endpoint: "notifications_cms",
    object: "notification_cms",
    header: [
      { text: "Fecha de creacion", value: "createdAt" },
      { text: "Email", value: "email_user", sortable: false },
      { text: "Name", value: "completed_name", sortable: false },
      { text: "Spot Alias", value: "alias_id" },
      { text: "Constancia Domicilio", value: "home_constancy", sortable: false },
      { text: "Cartel Colocado", value: "has_sticker", sortable: true },
      { text: "Verificado", value: "verified", sortable: false },
      { text: "Eliminado", value: "deleted", sortable: false },
      { text: "Cantidad Reviews", value: "rating_quantity"},
      { text: "Reviews", value: "spot_id", sortable: false },
      { text: "Días disponibles", value: "availabledays", sortable: false },
      { text: "Detalles", value: "details", sortable: false },
    ],
    list_valid: [],
    options: {
      sortBy: ["_id"],
      sortDesc: [false],
    },
  },
  mutations: {
    ...genericStore.mutations,
    success(state, data) {
      state.status = "success";

      if (data && data["list"]) {
        state.list = data["list"];
      }
      if (data && data["list_valid"]) {
        state.list_valid = data["list_valid"];
      }

      if (data && data["total"]) {
        state.total = data["total"];
      }
    },
  },
  actions: {
    ...genericStore.actions,
    getListAllNotifications({ commit, state }, options) {
      return new Promise((resolve, reject) => {
        commit("request");

        let filter = {
          ...options,
          search: "",
        };

        axios
          .get(config.api_url + state.endpoint, { paraiting_quantityms: filter })
          .then((response) => {
            commit("success", {
              list_valid: response.data,
            });
            resolve(response.data);
          })
          .catch((err) => {
            commit("error");
            reject(err);
          });
      });
    },
  },
  getters: {
    ...genericStore.getters,
  },
};
